// @react
import React from 'react'
// @libraries
import { makeStyles, createStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
// @components
import Grid from '@bit/atd.web.grid'
import colors from '@bit/atd.web.colors'
import Button from '@bit/atd.web.button'
import Icon from '@bit/atd.web.icons'
// @utils
import Helper from 'utils/Helper.class'

type PropTypes = {
  amount: number
  title: string
  description: string
  link: string
}

const useStyles = makeStyles(() =>
  createStyles({
    leftBlock: {},
    title: {
      color: colors.black,
      fontSize: '14px',
      maxWidth: '300px',
      '& > h6': {
        paddingBottom: '3px',
      },
    },
    amount: {
      color: colors.black,
      fontWeight: 600,
      fontSize: '40px',
      marginRight: '8px',
      lineHeight: 1,
    },
    linkText: {
      fontWeight: 500,
    },
    linkIcon: {
      width: '16px !important',
      marginLeft: '6px',
      color: colors.ctaPrimary,
    },
    description: {
      marginTop: '16px',
    },
  }),
)

const MetaInfo = (props: PropTypes) => {
  /******************************************
   * PROPS
   ******************************************/

  const { amount, title, description, link } = props

  /******************************************
   * HOOKS
   ******************************************/

  const classes = useStyles()

  /******************************************
   * RENDERS
   ******************************************/

  return (
    <>
      <Grid container justify="space-between" alignItems="flex-end">
        <Grid item className={classes.leftBlock}>
          <Grid container alignItems="flex-end">
            {/* Number */}
            <Grid item>
              <Typography
                className={classes.amount}
                variant="h3"
                component={'span'}
              >
                {Helper.formatThousandsNoRounding(amount, 0)}
              </Typography>
            </Grid>

            {/* Title */}
            <Grid item>
              <Typography
                className={classes.title}
                variant="subtitle2"
                component={'h3'}
              >
                {title}
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        {/* Link - View All */}
        <Grid item>
          <Button size={'small'} variant="tertiary" href={link}>
            <Typography
              className={classes.linkText}
              variant="subtitle2"
              component={'span'}
            >
              View All
            </Typography>
            <Icon glyph="arrow-right" className={classes.linkIcon} size={16} />
          </Button>
        </Grid>
      </Grid>

      {/* Description */}
      <Grid className={classes.description}>
        <Typography variant="body1" component={'p'}>
          {description}
        </Typography>
      </Grid>
    </>
  )
}

export default MetaInfo
